// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"1ddc0ab3","667":"d518774b"}[chunkId] + ".chunk.js";
};